export class OOMenu {
	venueKey: number;
	key?: string;
	name?: string;
	active?: boolean;
	externalLinks: OOMenuExternalLink[];

	unsaved?: boolean; //not from API. Local var only

	public constructor(init?: Partial<OOMenu>) {
		Object.assign(this, init);
	}
}

export class OOMenuExternalLink {
	label: string;
	url: string;
	public constructor(init?: Partial<OOMenuExternalLink>) {
		Object.assign(this, init);
	}
}
